import AccountProfile from './AccountProfile.container';

export default AccountProfile;
